import OrgDisplay from 'features/organizations/components/molecules/OrgDisplay/OrgDisplay';

export default OrgDisplay;
